import React from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import {
  NextButton,
  PreviousButton,
} from '../../components/Button/NavigationButton'

const StyledSchoolDetailPageNavigation = styled.div`
  display: flex;
`

interface ISchoolDetailsPageNavigationProps {
  schoolId: string
  onPrevClick: () => void
  onNextClick: () => void
}

const SchoolDetailsPageNavigation: React.FC<ISchoolDetailsPageNavigationProps> =
  ({ schoolId, onPrevClick, onNextClick }) => {
    const schools = useSelector(({ schools: s }) => s.list)
    const schoolIndex = schools.findIndex((s) => s.id === schoolId)
    const prevSchoolIndex = schoolIndex - 1
    const previousSchool = schoolIndex > 0 ? schools[prevSchoolIndex] : null
    const nextSchoolIndex = schoolIndex + 1
    const nextSchool =
      schoolIndex < schools.length - 1 ? schools[nextSchoolIndex] : null
    return (
      <StyledSchoolDetailPageNavigation>
        <PreviousButton
          onClick={() => onPrevClick(prevSchoolIndex)}
          disabled={!previousSchool}
        />
        <NextButton
          onClick={() => onNextClick(nextSchoolIndex)}
          disabled={!nextSchool}
        />
      </StyledSchoolDetailPageNavigation>
    )
  }

export { SchoolDetailsPageNavigation }
